export const BUCKET_MEDIA_HOST = 'googleusercontent.com';
